import type { Location } from "@stockline/shared/types/inventory/location"
import type { OfflineResourceConfig } from "../../../types"
import { LOCATION_TABLE } from "./db"

export const locationConfig: OfflineResourceConfig<Location> = {
  name: "locations",
  syncDisabled: false,
  endpoints: {
    full: "/api/v2/locations",
    delta: "/api/v2/locations/changes",
    push: "/api/v2/locations/changes",
  },
  tableName: LOCATION_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
